export interface AttachedDocumentRef {
  kind: 'lieferschein' | 'bestellung';
  id: string;
  number: string;
}

function tabLabel(kind: AttachedDocumentRef['kind']): string {
  return kind === 'lieferschein' ? 'Delivery notes' : 'To distributors';
}

export function formatDocumentToast(documents: AttachedDocumentRef[]): string {
  if (documents.length === 0) return '';
  const parts = documents.map((d) => `${d.number} (${tabLabel(d.kind)})`);
  if (parts.length === 1) return `Draft ${parts[0]} created`;
  return `Drafts created: ${parts.join(', ')}`;
}

export function formatReassignToast(documents: AttachedDocumentRef[]): string {
  if (documents.length === 0) return 'Distributor updated';
  const parts = documents.map((d) => `${d.number} (${tabLabel(d.kind)})`);
  if (parts.length === 1) return `Moved to ${parts[0]}`;
  return `Moved to ${parts.join(', ')}`;
}
